import { GAME_SOUNDS } from '../cfg/constants/game-constants';
export class AudioManager {
    constructor(scene) {
        this.bgSounds = new Map();
        this.sounds = new Map();
        this.isSoundOn = true;
        this.isMusicOn = true;
        this.scene = scene;
    }
    initBootAudio() {
        // If any audio needs to play in boot scene, add it here.
    }
    initGameAudio() {
        for (let i = 0, len = GAME_SOUNDS.length; i < len; ++i) {
            if (GAME_SOUNDS[i].loop) {
                this.bgSounds.set(GAME_SOUNDS[i].key, this.scene.sound.add(GAME_SOUNDS[i].key, {
                    volume: GAME_SOUNDS[i].volume,
                    loop: GAME_SOUNDS[i].loop,
                }));
            }
            else {
                this.sounds.set(GAME_SOUNDS[i].key, this.scene.sound.add(GAME_SOUNDS[i].key, {
                    volume: GAME_SOUNDS[i].volume,
                    loop: GAME_SOUNDS[i].loop,
                }));
            }
        }
    }
    initUIAudio() {
        for (let i = 0, len = GAME_SOUNDS.length; i < len; ++i) {
            if (GAME_SOUNDS[i].loop) {
                this.bgSounds.set(GAME_SOUNDS[i].key, this.scene.sound.add(GAME_SOUNDS[i].key, {
                    volume: GAME_SOUNDS[i].volume,
                    loop: GAME_SOUNDS[i].loop,
                }));
            }
            else {
                this.sounds.set(GAME_SOUNDS[i].key, this.scene.sound.add(GAME_SOUNDS[i].key, {
                    volume: GAME_SOUNDS[i].volume,
                    loop: GAME_SOUNDS[i].loop,
                }));
            }
        }
    }
    playClick() {
        this.play('click');
    }
    play(key, shouldStopPrevious = true) {
        if (!this.isSoundOn) {
            return;
        }
        const sound = this.sounds && this.sounds.get(key);
        if (this.sounds && sound) {
            if (shouldStopPrevious) {
                sound.stop();
            }
            sound.play();
        }
        else {
            console.warn(`Cannot find sound with key: ${key}`);
        }
    }
    playMusic(key, shouldStopPrevious = true) {
        if (!this.isMusicOn) {
            return;
        }
        const bgSound = this.bgSounds && this.bgSounds.get(key);
        if (bgSound) {
            if (shouldStopPrevious) {
                bgSound.stop();
            }
            bgSound.play();
        }
        else {
            console.warn(`Cannot find music with key: ${key}`);
        }
    }
    onceComplete(key, callback) {
        const sound = this.sounds && this.sounds.get(key);
        if (this.sounds && sound) {
            sound.play();
            sound.once('complete', () => {
                callback();
            });
        }
        else {
            console.warn(`Cannot find sound with key: ${key}`);
        }
    }
    stopSound(key) {
        const sound = this.sounds && this.sounds.get(key);
        if (this.sounds && sound) {
            sound.stop();
        }
        else {
            console.warn(`Cannot find sound with key: ${key}`);
        }
    }
    toggleSound() {
        this.isSoundOn = !this.isSoundOn;
        if (this.isSoundOn) {
            this.turnOnSound();
        }
        else {
            this.turnOffSound();
        }
    }
    toggleMusic() {
        this.isMusicOn = !this.isMusicOn;
        if (this.isMusicOn) {
            this.turnOnMusic();
        }
        else {
            this.turnOffMusic();
        }
    }
    checkIfSoundOn() {
        return this.isSoundOn;
    }
    checkIfMusicOn() {
        return this.isMusicOn;
    }
    turnOffMusic() {
        for (let i = 0, len = GAME_SOUNDS.length; i < len; ++i) {
            if (GAME_SOUNDS[i].loop) {
                this.bgSounds.get(GAME_SOUNDS[i].key).setVolume(0);
            }
        }
    }
    turnOnMusic() {
        for (let i = 0, len = GAME_SOUNDS.length; i < len; ++i) {
            if (GAME_SOUNDS[i].loop) {
                this.bgSounds.get(GAME_SOUNDS[i].key).setVolume(GAME_SOUNDS[i].volume);
            }
        }
    }
    turnOffSound() {
        for (let i = 0, len = GAME_SOUNDS.length; i < len; ++i) {
            if (!GAME_SOUNDS[i].loop) {
                this.sounds.get(GAME_SOUNDS[i].key).setVolume(0);
            }
        }
    }
    turnOnSound() {
        for (let i = 0, len = GAME_SOUNDS.length; i < len; ++i) {
            if (!GAME_SOUNDS[i].loop) {
                this.sounds.get(GAME_SOUNDS[i].key).setVolume(GAME_SOUNDS[i].volume);
            }
        }
    }
}
